import { render, staticRenderFns } from "./LessonQuiz.vue?vue&type=template&id=6961d454&scoped=true&"
import script from "./LessonQuiz.vue?vue&type=script&lang=js&"
export * from "./LessonQuiz.vue?vue&type=script&lang=js&"
import style0 from "./LessonQuiz.vue?vue&type=style&index=0&id=6961d454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961d454",
  null
  
)

export default component.exports